import { memo, useEffect, useMemo, useState } from "react";
import { instance } from "../../../constants/constString";
import { Table } from "antd";
import PrintMeritList from "./PrintMeritList";
import "./PrintMeritList.style.css";
const MeritList = ({ exam }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [meritList, setMeritList] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [startPrinting, setStartPrinting] = useState(false);

  useEffect(() => {
    setMeritList([]);
    const fetch = async () => {
      setIsLoading(true);
      try {
        const examType = exam?.isPracticeExam ? "PRACTICE" : "LIVE";
        const response = await instance.get(
          "/exam/getMeritListOfExam?examId=" +
            exam?._id +
            "&typeOfExam=" +
            examType
        );
        setMeritList(response?.data?.data ?? []);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };
    fetch();
  }, [exam]);

  const columns = useMemo(
    () => [
      {
        title: "SI. No",
        dataIndex: "rank",
        align: "center",
      },
      {
        title: "Name",
        render: (_, Obj) => Obj?.studentId?.name,
      },
      {
        title: "Subject",
        render: (_, obj) => obj?.subjectName ?? "N/A",
      },
      {
        title: "Total Obtained Marks",
        dataIndex: "marksObtained",
        align: "center",
        render: (_, obj) => tempMarkFormatter(obj?.marksObtained),
      },
      {
        title: "Negative Marks",
        dataIndex: "negativeMarks",
        align: "center",
        render: (_, obj) => tempMarkFormatter(obj?.negativeMarks),
      },
      {
        title: "Total Wrong Answer",
        dataIndex: "totalWrongAnswer",
        align: "center",
      },
      {
        title: "Overall Position",
        dataIndex: "rank",
        align: "center",
      },
      {
        title: "Faculty Position",
        render: (_, obj) => obj?.facultyPosition ?? "-",
        align: "center",
      },
      {
        title: "Subject Position",
        render: (_, obj) => obj?.subjectPosition ?? "-",
        align: "center",
      },
      {
        title: "Govt, Non-Govt, AMC & Other Position",
        render: (_, obj) => obj?.categoryPosition ?? "-",
        align: "center",
      },
    ],
    []
  );

  return (
    <div>
      <div>
        <h1>
          Merit List of <b>{exam?.title}</b>
        </h1>
        <h1>
          Course : <b>{exam?.courseName}</b>
        </h1>
        <p>
          Total Mark: <b>{tempMarkFormatter(exam?.totalMarks)}</b>
        </p>
        <p>
          Pass Mark: <b>{tempMarkFormatter(exam?.passMark)}</b>
        </p>
        {exam?.isSegmentedExam ? <p>Segmented Exam</p> : <></>}
        {/* <Button
          disabled={!meritList?.length}
          size="large"
          type="primary"
          icon={<PrinterFilled />}
          style={{ margin: "10px", marginLeft: "auto", width: "100px" }}
          onClick={async () => {
            setStartPrinting(true);
            setTimeout(() => {
              window.print();
            }, 1000);

            setTimeout(() => {
              setStartPrinting(false);
            }, 2000);
          }}
        >
          Print
        </Button> */}
      </div>

      <div>
        <Table
          style={{ overflowX: "auto" }}
          rowKey={(row) => row._id}
          loading={isLoading}
          columns={columns}
          dataSource={meritList}
        />
      </div>
      {startPrinting ? (
        <div className="print-merit-list">
          <PrintMeritList meritlist={meritList} />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default memo(MeritList);

const tempMarkFormatter = (mark) => {
  if (mark === null || mark === undefined) return "-";
  const num = Number(mark);
  return num % 1 === 0 ? num.toString() : num.toFixed(2);
};

// Apply filters efficiently
// const filteredMeritList = useMemo(() => {
//   return meritList
//     ?.filter((item) =>
//       candidateCategory ? item?.candidateCategory === candidateCategory : true
//     )
//     ?.filter((item) => (faculty ? item?.facultyName === faculty : true))
//     ?.filter((item) => (subject ? item?.subjectName === subject : true));
// }, [candidateCategory, faculty, subject, meritList]);
//  <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           gap: 10,
//           padding: "12px 0",
//         }}
//       >
//         <Select
//           allowClear
//           value={candidateCategory} // this value will be saved in localstorage for sending to exam completion submit
//           onChange={setCandidateCategory} // this value will be saved in localstorage for sending to exam completion submit
//           placeholder={"Candidate Category"}
//           options={candidateCategoryDDL}
//         />
//         <Select
//           allowClear
//           value={faculty} // this value will be saved in localstorage for sending to exam completion submit
//           onChange={(v, option) => {
//             setFaculty(v);
//             setSubject(null);
//             setSubjectListDDL(option?.subjects || null);
//           }} // this value will be saved in localstorage for sending to exam completion submit
//           placeholder={"Select Faculty"}
//           options={facultySubjectDDL}
//         />
//         <Select
//           allowClear
//           value={subject} // this value will be saved in localstorage for sending to exam completion submit
//           onChange={setSubject} // this value will be saved in localstorage for sending to exam completion submit
//           placeholder={"Select Subject"}
//           options={subjectListDDL}
//         />
//       </div>
